module.exports = __webpack_public_path__ + "img/MILFormula2.728601a0.png";